import { render, staticRenderFns } from "./Cnpj.vue?vue&type=template&id=43c87575"
import script from "./Cnpj.vue?vue&type=script&lang=js"
export * from "./Cnpj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports